/* eslint-disable no-nested-ternary */
/* eslint-disable max-params */
/* eslint-disable complexity */
import React, { useEffect } from "react";
import styles from "./styles.css";
import dropDown from "./images/arrow-grey.svg";
import dropDownBlue from "./images/arrow-blue.svg";
import PropTypes from "prop-types";
import PlatinumCoverExpandedSection from "../add-ons-expanded-section";
import CheckBlue from "./images/check-blue.svg";
import Selected from "./images/selected.svg";
import Check from "./images/check.svg";
import { trackMobileCustomEventsAU } from "../../../../tracking";
import PLATINUM_COVER_GA_EVENTS from "../add-ons/tracking";
import { makePriceLabelRound } from "../../../../utils/helpers/make-price-label";
import PostBcVasHighCostCard from "../../post-bc-vas-high-cost-card/component";
import Slider from "react-slick";
import PostBcVasPlatinumCoverSlidercard from "../../post-bc-vas-platinum-cover-slider-card/component";
import ComprehensiveServiceCheck from "../../../shared/comprehensive-service-check";
import BestPriceGuaranteed from "../../../shared/best-price-guaranteed";
import { VAS_CATEGORY_KEYS } from "../../../../constants/checkout-constants";
import PostBcVasPlatinumCoverSlidercardUpselling from "../../post-bc-vas-platinum-cover-slider-card-upselling/component";
import { getBoldText } from "../../../../utils/helpers/get-span-for-bold-text";

const getDescriptionText = ({ categoryKey, landingDescription, description }) => {
    if (categoryKey === VAS_CATEGORY_KEYS.WARRANTY || categoryKey === VAS_CATEGORY_KEYS.CAR_SERVICING) {
        return <p styleName={"styles.descriptionText"}>{description}</p>;
    }
    return <p styleName={`styles.bulletPoint`}>{landingDescription || description}</p>;
};

const getDescription = ({ categoryKey, landingDescription, description, specifications = [], handleModal, isStepAdded }) => {
    if (categoryKey === VAS_CATEGORY_KEYS.WARRANTY || categoryKey === VAS_CATEGORY_KEYS.CAR_SERVICING) {
        return (
            <div styleName={"styles.warrantyTextContainer"}>
                {!isStepAdded && <p styleName={"styles.descriptionText"}>{description}</p>}
                {specifications?.length > 0 && specifications.map((specification) => (
                    <div styleName={"styles.descriptionTextContainer"}>
                        <img src={CheckBlue} />
                        <p styleName={"styles.listDescriptionText"}>{getBoldText(specification.info)}</p>
                    </div>
                ))}
                {categoryKey !== VAS_CATEGORY_KEYS.CAR_SERVICING && <p onClick={handleModal} styleName={"styles.knowMoreContainer"}>
                    Know more
                </p>}
            </div>
        );
    }

    return <p styleName={"styles.warrantyText"}>{landingDescription || description}</p>;
};

const AddOnsPlan = ({
    isExpanded,
    setExpandedSection,
    planDetails,
    expandedSection,
    itemNumber,
    isStepSkipped,
    isStepAdded,
    handleKnowMoreModal,
    isDisabled,
    isFinanceUser,
    setShowAddonsNudge
}) => {
    const {
        title,
        categoryKey,
        landingDescription,
        skipText,
        vasPackage,
        bannerText,
        bannerImage,
        explorePlanDescription,
        addedPackage,
        leastRepaymentsPerWeek,
        comparisonData = null,
        upsellingEnabled = false,
        description = "",
        specifications = [],
        carouselBanner = [],
        planInfo = {},
        planOptionsHeader = {},
        itemCheckListInfo = {},
        marketingData = {}
    } = planDetails?.product || {};

    const addedPlanText =
        addedPackage?.length &&
        `${addedPackage[0]?.title || ""} ${
            isFinanceUser ? `(${makePriceLabelRound(addedPackage[0]?.repaymentsPerWeek)}/week)` : ""
        }`;

    useEffect(() => {
        if (isExpanded) {
            trackMobileCustomEventsAU("", {
                ...PLATINUM_COVER_GA_EVENTS.ADD_ONS_HOME_PAGE.PRODUCT_VIEWED,
                eventLabel: PLATINUM_COVER_GA_EVENTS.ADD_ONS_HOME_PAGE.PRODUCT_VIEWED.eventLabel(categoryKey)
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isExpanded]);

    const handleExpandedSection = () => {
        if (isExpanded) {
            setExpandedSection(null);
        } else {
            setExpandedSection(categoryKey);
        }
    };

    const handleModal = () => {
        handleKnowMoreModal(categoryKey);
    };

    const isVisited = !isDisabled;

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true
    };

    return (
        <div
            styleName={"styles.outer"}
            style={{
                maxHeight: isExpanded ? `1500px` : "67px",
                transition: "max-height 1.25s ease"
            }}
        >
            <div styleName={"styles.topSection"}>
                <div
                    className="media"
                    styleName={`styles.mediaContainer ${isVisited ? "styles.activeSection" : "styles.disabledSection"}`}
                >
                    {isStepAdded ? (
                        <img src={Selected} height={24} width={24} alt="Checkbox" />
                    ) : (
                        <p styleName={"styles.stepsCount"}>{itemNumber}</p>
                    )}
                    <div className="media-body">
                        <p styleName={"styles.heading"}>
                            {title}
                            <img
                                src={isVisited ? dropDownBlue : dropDown}
                                alt="Accordion image"
                                style={{ transform: isExpanded ? "rotate(0deg)" : "rotate(180deg)" }}
                                onClick={handleExpandedSection}
                            />
                        </p>
                        {isStepAdded ? (
                            <p styleName={"styles.bulletPoint"}>
                                <img src={Check} /> {addedPlanText}
                            </p>
                        ) : !isExpanded ?
                            getDescriptionText({ categoryKey, landingDescription, description })
                            : null}
                    </div>
                </div>
                {isExpanded &&
                    getDescription({ categoryKey, landingDescription, description, specifications, handleModal, isStepAdded })}

                {isExpanded && categoryKey === VAS_CATEGORY_KEYS.CAR_SERVICING && (
                    <React.Fragment>
                        <div styleName={"styles.comprehensiveWrapper"}><ComprehensiveServiceCheck onModalOpen={handleModal} benefits={itemCheckListInfo} /></div>
                        <div styleName={"styles.comprehensiveWrapper"}><BestPriceGuaranteed marketingData={marketingData} /></div>
                    </React.Fragment>
                )}

                {isExpanded && ([VAS_CATEGORY_KEYS.WARRANTY, VAS_CATEGORY_KEYS.CAR_COVER_BUNDLES].includes(categoryKey)) && (
                    <React.Fragment>

                        {!upsellingEnabled && <div styleName={"styles.comprehensiveCard"}>
                            <PostBcVasHighCostCard />
                        </div>}
                        {!upsellingEnabled && <div styleName={"styles.sliderContainer"}>
                            <Slider {...settings}>
                                {carouselBanner?.bannerInfo?.length > 0 &&
                                    carouselBanner?.bannerInfo?.map((banner) => (
                                        <PostBcVasPlatinumCoverSlidercard
                                            heading={banner?.title}
                                            subHeading={banner?.description}
                                            image={banner?.iconUrl}
                                        />
                                    ))}
                            </Slider>
                        </div>
                        }
                        {upsellingEnabled && <div styleName={"styles.sliderContainer"}>
                            <Slider {...settings}>
                                {carouselBanner?.bannerInfo?.length > 0 &&
                                    carouselBanner?.bannerInfo?.map((banner) => (
                                        <PostBcVasPlatinumCoverSlidercardUpselling
                                            heading={banner?.title}
                                            subHeading={banner?.description}
                                            image={banner?.iconUrl}
                                        />
                                    ))}
                            </Slider>
                        </div>
                        }
                    </React.Fragment>
                )}
            </div>

            <PlatinumCoverExpandedSection
                isExpanded={isExpanded}
                productList={vasPackage}
                planKey={categoryKey}
                skipText={skipText}
                setExpandedSection={setExpandedSection}
                expandedSection={expandedSection}
                isStepSkipped={isStepSkipped}
                isStepAdded={isStepAdded}
                additionalInfoText={explorePlanDescription}
                handleKnowMoreModal={handleKnowMoreModal}
                categoryKey={categoryKey}
                bannerText={bannerText}
                bannerImage={bannerImage}
                isFinanceUser={isFinanceUser}
                setShowAddonsNudge={setShowAddonsNudge}
                leastRepaymentsPerWeek={leastRepaymentsPerWeek}
                planInfo={planInfo}
                planOptionsHeader={planOptionsHeader}
                upsellingEnabled={upsellingEnabled}
                comparisonData={comparisonData}
            />
        </div>
    );
};

AddOnsPlan.propTypes = {
    handleKnowMoreModal: PropTypes.func,
    planDetails: PropTypes.object,
    isExpanded: PropTypes.bool,
    setExpandedSection: PropTypes.func,
    navigateToNextScreen: PropTypes.func,
    planKey: PropTypes.string,
    title: PropTypes.string,
    expandedSection: PropTypes.string,
    itemNumber: PropTypes.number,
    isStepSkipped: PropTypes.bool,
    isStepAdded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    bannerText: PropTypes.string,
    bannerImage: PropTypes.string,
    isFinanceUser: PropTypes.bool,
    setShowAddonsNudge: PropTypes.func
};

export default AddOnsPlan;
